<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view v-if="isRouterAlive"></router-view>
    </a-config-provider>

    <div class="slider_class " :class="showIm ? '' :  'hide_slider'">
      <div @click="showAndHide" class="operationBtn_">
      <a-icon type="left" v-if="!showIm" />
      <a-icon type="right" v-else />
      
      </div>
      <div class="jumpBox" v-if='jump' @click="jump_">
        <img src="./assets/icon/tas2.jpg" alt="">
      </div>
      <!-- <div class="jumpBox" v-show="service_" @click="service"> -->
      <div class="jumpBox" @click="service">
        <img src="./assets/icon/im.jpg" alt="">
      </div>
    </div>
    <div id="backTop"  style="position:fixed;bottom:30px;right:30px;cursor:pointer;font-size: 30px;" @click="toTop">
      <!-- <a-tooltip>
      <template slot="title">
        返回顶部
      </template> -->
      <a-icon type="up" />
      <!-- </a-tooltip> -->
    </div>
    



    <!-- <div class="tip" v-if="unreadCount > 0">{{unreadCount}}</div> -->


    <div v-if="flang">
      <Im v-if="flang" @close="flang = false" class="bounced_"></Im>
    </div>


  </div>
  
</template>

<script>
const global = require('../../static/global')
import { afterLogin } from '../Master/utils/commonLogin'

import {
  thequery,
  changeSystem
} from './api/channel.js'
import Cookies from 'js-cookie'
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { initSettingBycurrUser } from './api/common'
import { queryByUser } from './api/im.js'
import Im from "./views/Im/Im.vue"
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    }
  },
  components: {
    Im
  },
  watch: {
    flang() {
      this.initRecentContactList()
    }
  },
  data() {
    return {
      global,
      locale: zhCN,
      unreadCount: 0,//未读消息数
      friends: [],  //消息列表
      jump: false,
      service_: false,
      flang: false,
      query: {
        // token: '',
        systemType: 1
      },
      from: {
        buttonStatus: true,
        hasSystem: true,
        systemType: 2
      },
      isRouterAlive: true,
      ims: true,
      showIm: false
    };
  },
  mounted() {
    localStorage.setItem('systemType',1)
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('tagsList', "[]")
      for (let key in localStorage) {
        if (key.indexOf('cache') > -1) {
          localStorage.setItem(key, '')
        }
      }
    });
    window.addEventListener('storage', function (e) {
      if (e.key && e.key == 'identifying' && e.newValue && (e.newValue != e.oldValue)) {
        window.history.go(0)
      }
    })
  },
  created() {

    localStorage.setItem('imAccount', "")
    localStorage.setItem('userSig', "")
    var that = this
    var token = Cookies.get('app.token', { domain: this.global.cookiePath })
    if (token) {
      localStorage.setItem('identifying', token)
    }
    setTimeout(() => {
      if (this.$route.query.isEntry) {
        this.service_ = false
        return
      } else {
        this.service_ = true
      }
      this.thequerys()
      this.$store.dispatch('getIndex')

      setTimeout(function () {
        that.queryByUser()
      }, 500)
      that.initRecentContactList()

      that.$tim.on(that.$TIMS.EVENT.MESSAGE_RECEIVED, (event) => {
        // console.log(event, '新消息666')
        that.initRecentContactList()
      })
    }, 3000)

    // initSettingBycurrUser();//登陆成功后调这个接口
    if (this.$route.query.isEntry == null) {
      this.ims = false
    }
  },
  methods: {
    toTop(){
      document.querySelector('.main-content').scrollTop = 0
    },
    showAndHide() {
      this.showIm = !this.showIm
    },
    service() {
      console.log('--------------------')
      this.flang = !this.flang
    },

    // 获取Im账号
    queryByUser() {
      queryByUser().then(res => {
        localStorage.setItem("imAccount", res.data.imAccount);
        localStorage.setItem("userSig", res.data.userSig);
        localStorage.setItem("accountType", res.data.accountType);
      })
    },

    // im获取未读消息数
    initRecentContactList() {
      var that = this
      // console.log(this.$tim, 'time22')
      let promise2 = this.$tim.login({
        userID: localStorage.getItem('imAccount'),
        userSig: localStorage.getItem('userSig'),
      });
      promise2.then(function (imResponse) {
        // console.log(imResponse, '登陆成功')
      }).catch(function (imError) {
        // util.sLoadingHide()

      })
      let promise = that.$tim.getConversationList();
      promise.then(function (imResponse) {
        // console.log(imResponse, '获取会话列表接口res')
        const conversationList = imResponse.data.conversationList; // 会话列表，用该列表覆盖原有的会话列表
        console.log(conversationList, '====获取会话列表接口666666666666=======')
        // that.friends = conversationList
        var aa = 0
        conversationList.forEach(item => {
          aa += item.unreadCount
        })
        that.unreadCount = aa
      }).catch(function (imError) {
        console.warn('getConversationList error:', imError); // 获取会话列表失败的相关信息
      });
    },

    thequerys() {
      this.query.token = Cookies.get().token
      console.log(this.query.token, '=============')
      thequery(this.query).then(res => {
        if (res.code == 200) {
          this.from = res.data
          if (res.data.buttonStatus) {
            this.jump = true
          } else {
            this.jump = false
          }
        }
      })
    },

    // 跳转系统点击事件
    jump_() {
      // if (!this.from.buttonStatus) {
      //   return
      // }
      this.query.systemType = this.from.systemType
      // console.log()
      changeSystem({ systemType: 2 }).then(res => {
        if (res.code == 200) {
          this.$message.success("系统切换成功,正在跳转请稍后")
          afterLogin.call(this, res, 2);
        } else {
          this.$message.error('系统切换异常,请联系管理员')
        }
        // return 
        // if (res.code == 200) {
        //   // Cookies.set('app.token_TAS', res.data.token, global.path + ':7020')
        //   // Cookies.set('logindata_TAS', res.data, global.path + ':7020')
        //   // window.location.href = global.path + ":7020"

        //   Cookies.set('app.token_TAS', res.data.token, {domain:global.cookiePath})
        //   Cookies.set('logindata_TAS', res.data, {domain:global.cookiePath})
        //   window.location.href = global.tasPath
        // }
      })
    },
    reload() {
      window.location.reload()
      return
      var path = this.$route.fullPath
      // console.log('reload path,,,,,',path,this.$route);
      // return 
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
        this.$router.push(path ? path : '')
      })
    }
  }
};

</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  height: 100%;
  display: flex;
}

.home .content {
  overflow-x: hidden;
}

.jump img {
  width: 86px;
  height: 86px;
  border-radius: 43px;
  position: absolute;
  bottom: 1.6%;
  right: 5.5%;
  z-index: 1001;
}

.bgColor {
  background: #c7c7c7d7
}

.service img {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  position: absolute;
  bottom: 2%;
  right: 1%;
  z-index: 999;
}

.bounced_ {
  width: 1000px !important;
  // height: 70%;
  height: 654px !important;
  // border: 1px solid rgb(163, 163, 163);
  // background: rgb(160, 160, 160);
  height: 654px !important;
  position: fixed !important;
  top: 15%;
  // left: 25%;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  border-radius: 20px;
  z-index: 99
}

.tip {
  position: absolute;
  z-index: 1000;
  /* top: -3px;
        left: 40px; */
  bottom: 82px;
  right: 30px;
  height: 22px;
  min-width: 22px;
  font-size: 12px;
  color: #fffffe;
  line-height: 22px;
  text-align: center;
  background: #e24444;
  border-radius: 16px;
}


.slider_class {
  position: fixed;
  right: 0;
  bottom: 20px;
  width:auto;
  height: 100px;
  background: #605ca8;
  border-radius: 10px 0 0 10px;
  // transition: right 0.5s;
  padding-left: 25px;
  text-align: right;
  overflow: hidden;
  z-index:999;

}

.operationBtn_ {
  position: absolute;
  height: 100%;
  width: 20px;
  background: rgba(255,255,255,0.2);
  line-height: 100px;
  text-align: center;
  font-size: 20px;
  color: white;
  left: 0;
  top: 0;
  cursor: pointer;
}

.hide_slider {
  right: -5px;
  width:0
}

.jumpBox {
  display: inline-block;
  // margin-top: 20rpx;
  position: relative;
  top: 8px;
  margin-right: 5px;
}

.jumpBox img {
  width: 86px;
  height: 86px;
  border-radius: 43px;
  z-index: 1001;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/SRM/App.vue